import {
  PaymentReason,
  PaymentStatus,
  PaymentType,
} from './payment.interfaces';

export const paymentStatusLabels = {
  [PaymentStatus.CANCELLED]: $localize`Cancelled`,
  [PaymentStatus.EXPIRED]: $localize`Expired`,
  [PaymentStatus.FAILED]: $localize`Failed`,
  [PaymentStatus.PAID]: $localize`Paid`,
  [PaymentStatus.PENDING]: $localize`Pending`,
  [PaymentStatus.IN_PROGRESS]: $localize`Processing externally`,
  ['null']: $localize`No payment`,
} as const satisfies {
  [k in PaymentStatus | 'null']: string;
};

export const paymentTypeLabels = {
  [PaymentType.ONFACT]: $localize`Bank transfer`,
  [PaymentType.STRIPE]: $localize`Online`,
  [PaymentType.PONTO]: $localize`Outgoing`,
} as const satisfies {
  [k in PaymentType]: string;
};

export const paymentReasonLabels = {
  [PaymentReason.Order]: $localize`Order`,
  [PaymentReason.DiscountReimbursement]: $localize`Reimbursed discount`,
  [PaymentReason.ExpenseNote]: $localize`Reimbursed expense`,
  [PaymentReason.RegistrationReimbursement]: $localize`Reimbursement`,
  [PaymentReason.Wage]: $localize`Wage`,
  [PaymentReason.EnteredByAdministrator]: $localize`Created by admin`,
} as const satisfies { [k in PaymentReason]: string };
